import { Link } from 'react-router-dom';
import './App.css';

// CDN URLs for images
const LOGO_URL = 'https://cdn.prod.website-files.com/66f564eed0595486171edd49/691e0019b62c2cf13ddaa0db_Cancer%20Check%20Test%20Logo_Main.png';
const KIT_BOX_URL = 'https://cdn.prod.website-files.com/66f564eed0595486171edd49/693042f2d019f9f8944fca14_ccl%20box%20white%20background.png';
const CARD_FRONT_URL = 'https://cdn.prod.website-files.com/66f564eed0595486171edd49/693042f28312f7fc2e8ce500_kit%20registration%20final%20front.png';
const CARD_BACK_URL = 'https://cdn.prod.website-files.com/66f564eed0595486171edd49/69304f535ea7e42d34a684aa_kit%20registration%20final%20back.png';
const ICON_SECURE_URL = 'https://cdn.prod.website-files.com/66f564eed0595486171edd49/69305c20e288f885e8fd8eb1_padlock.png';
const ICON_FAST_URL = 'https://cdn.prod.website-files.com/66f564eed0595486171edd49/69305c1eca72ff2e8f1861f4_deadline.png';
const ICON_PERSONALIZED_URL = 'https://cdn.prod.website-files.com/66f564eed0595486171edd49/69305c1e2ead7c8e6b69be61_personalized.png';

// Header Component
const Header = () => (
  <header className="app-header">
    <div className="header-content">
      <a href="https://www.cancerchecklabs.com/">
        <img src={LOGO_URL} alt="Cancer Check" className="logo-img" />
      </a>
    </div>
  </header>
);

// Footer Component
const Footer = () => (
  <footer className="app-footer">
    <div className="footer-content">
      <div className="footer-address">
        <p>1303 Medical District Drive, Dallas, TX 75207</p>
      </div>
      <div className="footer-copyright">
        <p>&copy; 2025 Cancer Check Labs. All rights reserved.</p>
      </div>
      <div className="footer-divider"></div>
      <div className="footer-disclaimer">
        <p>This content does not provide medical or healthcare advice. The information, including but not limited to, text, graphics, images and other material contained here are for informational purposes only. No material in this content is intended to be a substitute for professional medical advice, diagnosis or treatment. Always seek the advice of your physician or other qualified healthcare provider with any questions you may have regarding a medical condition or treatment and before undertaking a new health care regimen and never disregard professional medical advice or delay in seeking it because of something you have read in this content.</p>
        <p>Cancer Check Labs' clinical laboratory has earned a Federal Certificate of Compliance under the Clinical Laboratory Improvement Amendments of 1988 (CLIA), which is regulated by the Centers for Medicare and Medicaid Services (CMS). The Cancer Check test is not intended to diagnose, treat, cure, or prevent any disease and should not replace established, evidence-based screening, diagnostic, or medical guidelines for cancer detection. Like all medical tests, it has limitations and may not detect all cancers. While the Cancer Check test has not been cleared or approved by the Food and Drug Administration (FDA), both the FDA and CMS operate under the U.S. Department of Health and Human Services (HHS).</p>
      </div>
    </div>
  </footer>
);

// Need Help Component
const NeedHelp = () => (
  <div className="need-help">
    <h4>Need Help?</h4>
    <p>Call us at <a href="tel:214-301-0351">214-301-0351</a> or email <a href="mailto:hello@cancerchecklabs.com">hello@cancerchecklabs.com</a></p>
  </div>
);

const Instructions = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />

      <main style={{ flex: 1 }}>
        {/* Hero Section */}
        <section className="instructions-hero">
          <div className="container">
            <div className="instructions-hero-content">
              <div className="instructions-hero-text">
                <h1>Register Your Cancer Check Kit</h1>
                <p className="subtitle">Complete your registration to receive your test results securely and on time.</p>
                <div className="instructions-hero-cta">
                  <Link to="/" className="register-btn">Register Now</Link>
                </div>
              </div>
              <div className="instructions-hero-image">
                <img src={KIT_BOX_URL} alt="Cancer Check Test Kit" />
              </div>
            </div>
          </div>
        </section>

        {/* How to Register Section */}
        <section className="how-to-register">
          <div className="container">
            <h2>How to Register Your Kit</h2>

            <div className="steps-container">
              {/* Step 1 */}
              <div className="step-wrapper">
                <div className="step-timeline">
                  <div className="step-number">1</div>
                  <div className="step-line"></div>
                </div>
                <div className="step">
                  <div className="step-content">
                    <h3>Find Your Registration Card</h3>
                    <p>Inside your Cancer Check kit, you'll find a registration card. This card contains everything you need to register your kit.</p>
                  </div>
                  <div className="step-image">
                    <img src={CARD_FRONT_URL} alt="Registration Card Front" />
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="step-wrapper">
                <div className="step-timeline">
                  <div className="step-number">2</div>
                  <div className="step-line"></div>
                </div>
                <div className="step">
                  <div className="step-content">
                    <h3>Scan QR Code or Enter Your Code</h3>
                    <p>Flip the card over to find your unique registration code. You have two options:</p>
                    <div className="registration-options">
                      <div className="option option-recommended">
                        <span className="option-badge">Fastest</span>
                        <strong>Scan the QR Code</strong>
                        <p>Use your phone's camera to scan - no need to type your code!</p>
                      </div>
                      <div className="option-divider">or</div>
                      <div className="option">
                        <strong>Enter Your Code Manually</strong>
                        <p>Type your 16-digit alphanumeric code</p>
                      </div>
                    </div>
                  </div>
                  <div className="step-image">
                    <img src={CARD_BACK_URL} alt="Registration Card Back with QR Code" />
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="step-wrapper">
                <div className="step-timeline">
                  <div className="step-number">3</div>
                  <div className="step-line"></div>
                </div>
                <div className="step">
                  <div className="step-content">
                    <h3>Complete Your Registration</h3>
                    <p>Follow the prompts to enter your information and sign off on any forms. When registration is complete, you will receive a confirmation email along with information on how to set up your blood draw.</p>
                  </div>
                  <div className="step-image step-image-small">
                    <img src={KIT_BOX_URL} alt="Cancer Check Kit Box" />
                  </div>
                </div>
              </div>
            </div>

            <div className="section-cta">
              <Link to="/" className="register-btn">Register Now</Link>
            </div>

            <NeedHelp />
          </div>
        </section>

        {/* Why Register Section */}
        <section className="why-register">
          <div className="container">
            <h2>Why Registration is Essential</h2>

            <div className="alert-box">
              <p>Unregistered kits may be discarded. Without registration, we cannot link your sample to your account or deliver your results.</p>
            </div>

            <div className="benefits">
              <div className="benefit-card">
                <div className="benefit-icon">
                  <img src={ICON_SECURE_URL} alt="Secure" />
                </div>
                <h3>Secure Results Delivery</h3>
                <p>Your results are linked directly to your account for private, secure access.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">
                  <img src={ICON_FAST_URL} alt="Fast" />
                </div>
                <h3>Faster Processing</h3>
                <p>Registered kits are processed immediately upon arrival at our lab.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">
                  <img src={ICON_PERSONALIZED_URL} alt="Personalized" />
                </div>
                <h3>Personalized Care</h3>
                <p>Registration connects your sample to your profile for seamless customer service.</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <h2>Ready to Register?</h2>
            <p>Have your registration card handy and click the button below to begin.</p>
            <Link to="/" className="register-btn">Register Now</Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Instructions;
